import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=08822cbe&scoped=true"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=08822cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08822cbe",
  null
  
)

export default component.exports